import { StdProposalTariffItemTierEntity } from "./StdProposalTariffItemTierEntity"

export interface StandardProposalItemPreviewEntity {

    itemId: string,
    companyCode: string,
    tariffType: string,
    tariffCode?: string | null,
    forwarderCode?: string | null,
    copyToNewTariffItemTierList: StdProposalTariffItemTierEntity[],


    [key: string]: string | boolean | number | Date | null | undefined | Object
}

export const EMPTY_STANDARD_PROPOSAL_ITEM_PREVIEW_ENTITY: StandardProposalItemPreviewEntity = {
    itemId: "",
    companyCode: "",
    tariffType: "",
    tariffCode: null,
    forwarderCode: null,
    copyToNewTariffItemTierList: []
}